import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import Hamburger from 'react-hamburgers';

import AppMobileMenu from '../AppMobileMenu';

import {
    setEnableClosedSidebarView,
    setEnableMobileMenuViewRevise,
    setEnableMobileMenuSmallViewRevise,
} from '../../Reducers/ThemeOptions';

class HeaderLogo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeWeb: false,
            mobile: false,
            activeSecondaryMenuMobile: false,
        };
    }

    toggleEnableClosedSidebar = () => {
        let { enableClosedSidebar, setEnableClosedSidebarView } = this.props;
        setEnableClosedSidebarView(!enableClosedSidebar);
    }

    state = {
        openLeft: false,
        openRight: false,
        relativeWidth: false,
        width: 280,
        noTouchOpen: false,
        noTouchClose: false,
    };

    render() {
        let {
            enableClosedSidebar,
        } = this.props;

        return (
            <Fragment>
                <div className="app-header__logo">
                
                <div className="logo-src"
                    style={{flexWrap: "nowrap", marginRight: "0px", marginLeft: "50px", top: "20px", display: "flex", alignItems: "center",
                        gap: "0px"}}>
                    <img
                        src={`${process.env.PUBLIC_URL}/images/neo_automatatm_logo_white3.png`}
                        alt="logo"                            
                        className="inner-logo"
                        style={{width: "126px", left:"-60px",height:"60px",right:"50px",top:"-25px"}}
                    />
                    <img
                        src={`${process.env.PUBLIC_URL}/images/pngdatacoLogo.png`}
                        alt="logo"                            
                        className="inner-logo"
                        style={{width: "110px", right:"100px",height:"44px",left:"50px"}}
                    />
                </div>
                    <div className="header__pane ml-auto">
                        <div onClick={this.toggleEnableClosedSidebar}>
                            <Hamburger
                                active={enableClosedSidebar}
                                type="elastic"
                                
                                onClick={() => this.setState({ activeWeb: !this.state.activeWeb })}
                            />
                        </div>
                    </div>
                </div>
                <AppMobileMenu />
            </Fragment>
        )
    }
}


const mapStateToProps = state => ({
    enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
    enableMobileMenuView: state.ThemeOptions.enableMobileMenuView,
    enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = dispatch => ({

    setEnableClosedSidebarView: enable => dispatch(setEnableClosedSidebarView(enable)),
    setEnableMobileMenuViewRevise: enable => dispatch(setEnableMobileMenuViewRevise(enable)),
    setEnableMobileMenuSmallViewRevise: enable => dispatch(setEnableMobileMenuSmallViewRevise(enable)),

});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLogo);




